import { useQuery } from '@tanstack/react-query';
import skillsService from '../services/skillsService';

export function useSkills(options = {}) {
  return useQuery({
    queryKey: ['skills-list'],
    queryFn: () => skillsService.getAllSkills(),
    staleTime: Infinity,
    ...options,
  });
}

export function useSkillDetail(skillId, options = {}) {
  return useQuery({
    queryKey: ['skill-detail', skillId],
    queryFn: () => skillsService.getSkillDetails(skillId),
    enabled: !!skillId,
    ...options,
  });
}
